import { BaseResponseHttp } from './commons.model';
import { BooleanCons, NumberCons, StringConst } from '../../constants/const';
import { DetailProduct, IProducts } from './myActivity.model';
export class ICatalogsResponse extends BaseResponseHttp {
  response?: ICatalogs[];
}
export class ICatalogs {
  fieldId: number;
  description: string;
  value: string;
  itemCode: string[];
  constructor() {
    this.fieldId = NumberCons.zero;
    this.description = StringConst.empty;
    this.value = StringConst.empty;
    this.itemCode = [];
  }
}

export class IListProductType extends BaseResponseHttp {
  response?: IProducts[];
}

export class IListSearchProductType extends BaseResponseHttp {
  response?: ItemSearchProductType;
}
export class IDownloadCatalogs extends BaseResponseHttp {
  response?: DownloadCatalogs;
}
export interface ICatalgosDermaRes extends BaseResponseHttp {
  response: ICatalogsDerma[];
}
export interface ISelectCatalogsRes extends BaseResponseHttp {
  response: ISelectCatalogs;
}
export interface ISelectCatalogs {
  ailments: ItemClassification[];
  specialities: ItemClassification[];
  actives: ItemClassification[];
  presentation: ItemClassification[];
  sublines: ItemClassification[];
  indication: ItemClassification[];
}
export interface IGeneralFiltersResponse extends BaseResponseHttp {
  response: GeneralFilters;
}
export class GeneralFilters {
  dermazone: SelectedItemsClassification;
  reve: SelectedItemsClassification;
  biequal: SelectedItemsClassification;
  bioelite: SelectedItemsClassification;
  omigenomics: SelectedItemsClassification;
  constructor() {
    this.reve = new SelectedItemsClassification();
    this.dermazone = new SelectedItemsClassification();
    this.bioelite = new SelectedItemsClassification();
    this.biequal = new SelectedItemsClassification();
    this.omigenomics = new SelectedItemsClassification();
  }
}

export class SelectedItemsClassification implements ISelectCatalogs {
  ailments: ItemClassification[];
  specialities: ItemClassification[];
  actives: ItemClassification[];
  presentation: ItemClassification[];
  sublines: ItemClassification[];
  indication: ItemClassification[];
  constructor() {
    this.ailments = [];
    this.specialities = [];
    this.actives = [];
    this.presentation = [];
    this.sublines = [];
    this.indication = [];
  }
}
export class SelectedItemsGeneral extends SelectedItemsClassification {
  catalogs: ItemClassification[];
  constructor() {
    super();
    this.catalogs = [];
  }
}
export class GeneralChipFilter {
  value = StringConst.empty;
  key = StringConst.empty;
  index = 0;
  constructor(value: string, key: string, index: number) {
    this.value = value;
    this.key = key;
    this.index = index;
  }
}
export class BaseItemClassification {
  specialityIds: number[] = [];
  ailmentIds: number[] = [];
}
export class ItemClassification extends BaseItemClassification {
  description: string;
  value: string;
  definition: string;
  urlImg: string;
  id: number;
  idSpecialityByAliment?: number;
  idAlimentByActive?: number;
  cardTitle: string;
  alternateNames?: string[];
  constructor() {
    super();
    this.description = StringConst.empty;
    this.value = StringConst.empty;
    this.definition = StringConst.empty;
    this.urlImg = StringConst.empty;
    this.id = NumberCons.zero;
    this.idSpecialityByAliment = NumberCons.zero;
    this.idAlimentByActive = NumberCons.zero;
    this.cardTitle = StringConst.empty;
  }
}

export class FilterItemClassification {
  selected: boolean;
  item: ItemClassification;
  constructor() {
    this.selected = BooleanCons.false;
    this.item = new ItemClassification();
  }
}

export interface ItemInformation {
  typeProduct: string;
  item: ItemClassification;
  generateSearch: boolean;
}
export interface ICatalogsDerma {
  id: number;
  name: string;
  value: string;
  isSelected?: boolean;
}
export interface ICatalogsMissingProRes extends BaseResponseHttp {
  response: ICatalogsMissingPro[];
}
export interface ICatalogsMissingPro {
  value: string;
}
export class IcatalogClassification extends BaseResponseHttp {
  response?: CatalogClassification[];
}

export interface CatalogClassification {
    catalogName: string;
    imageUrl: string;
    filters: CatalogFilters[];
    typeview: number;
    description: string;
}

export interface CatalogFilters {
  title: string;
  filter: string;
}

export class ItemProductSegmentation {
  nameCatalog: string;
  productSegmentation: string;
  constructor() {
    this.nameCatalog = StringConst.empty;
    this.productSegmentation = StringConst.empty;
  }
}
export class DeleteInputSelect {
  inputDelete: string;
  allDelete: boolean;
  listSpecialityByAliment: number[];
  listOnlySpecialtiesSelect: number[];
  filtersChips: string[];
  groupName: string;
  typeCatalog: string;
  constructor() {
    this.inputDelete = StringConst.empty;
    this.allDelete = false;
    this.listSpecialityByAliment = [];
    this.listOnlySpecialtiesSelect = [];
    this.filtersChips = [];
    this.groupName = StringConst.empty;
    this.typeCatalog = StringConst.empty;
  }
}

export class ItemSearchProductType {
  catalogUrl: string;
  products?: DetailProduct[];
  constructor() {
    this.catalogUrl = StringConst.empty;
  }
}
export class DownloadCatalogs {
  mainCatalog: Catalog[];
  catalogs: Catalog[];
  dosageGuide: Catalog;
  constructor() {
    this.mainCatalog = [];
    this.catalogs = [];
    this.dosageGuide = new Catalog();
  }
}

export class Catalog {
  name: string;
  catalogUrl: string;
  isMain: number;
  idSpecialityClassification: number;
  catalogId: number;
  idMainCatalog: number;
  isDosageGuide: boolean;
  constructor() {
    this.name = StringConst.empty;
    this.catalogUrl = StringConst.empty;
    this.isMain = 0;
    this.idSpecialityClassification = 0;
    this.catalogId = NumberCons.zero;
    this.idMainCatalog = NumberCons.zero;
    this.isDosageGuide = BooleanCons.false;
  }
}

export class CatalogsList {
  mainCatalog: Catalog;
  childCatalogs: Catalog[];
  constructor() {
    this.mainCatalog = new Catalog();
    this.childCatalogs = [];
  }
}
export interface IDermazoneReq {
  cardCode: string;
  ailments: string[];
  offset: string;
  limit: string;
}
export class ParamsSearchDefault {
  ailments: boolean;
  active: boolean;
  code: boolean;
  specialty: boolean;
  presentation: boolean;
  subLines: boolean;
  size: number;
  constructor() {
    this.ailments = false;
    this.active = false;
    this.code = false;
    this.specialty = false;
    this.presentation = false;
    this.size = NumberCons.zero;
    this.subLines = false;
  }
}

export const paramsSearchBioEqual = new ParamsSearchDefault();
paramsSearchBioEqual.ailments = true;
paramsSearchBioEqual.active = true;
paramsSearchBioEqual.code = true;
paramsSearchBioEqual.specialty = true;
paramsSearchBioEqual.presentation = false;
paramsSearchBioEqual.size = 4;

export const paramsSearchBioElite = new ParamsSearchDefault();
paramsSearchBioElite.ailments = false;
paramsSearchBioElite.active = true;
paramsSearchBioElite.code = true;
paramsSearchBioElite.specialty = true;
paramsSearchBioElite.presentation = true;
paramsSearchBioElite.size = 3;

export const paramsSearchReve = new ParamsSearchDefault();
paramsSearchReve.ailments = false;
paramsSearchReve.subLines = true;
paramsSearchReve.active = false;
paramsSearchReve.code = true;
paramsSearchReve.specialty = false;
paramsSearchReve.presentation = false;
paramsSearchReve.size = 2;

export const paramsSearchDermazone = new ParamsSearchDefault();
paramsSearchDermazone.ailments = true;
paramsSearchDermazone.active = true;
paramsSearchDermazone.code = true;
paramsSearchDermazone.specialty = false;
paramsSearchDermazone.presentation = true;
paramsSearchDermazone.size = 4;

export const paramsSearchOmigenomics = new ParamsSearchDefault();
paramsSearchOmigenomics.ailments = true;
paramsSearchOmigenomics.active = true;
paramsSearchOmigenomics.code = true;
paramsSearchOmigenomics.specialty = true;
paramsSearchOmigenomics.presentation = false;
paramsSearchOmigenomics.size = 4;

export const paramsSearchOtherCatalogs = new ParamsSearchDefault();

export class BaseParamsSearch {
  cardCode: string;
  offset: number;
  limit: number;
  ailments: string;
  activesPrinciples: string;
  specialitys: string;
  displays: string;
  generalSearch: string;
  specialityDoctor: string;
  priceListId: number;
  clientType: string;
  constructor() {
    this.cardCode = StringConst.empty;
    this.offset = NumberCons.zero;
    this.limit = NumberCons.zero;
    this.ailments = StringConst.empty;
    this.activesPrinciples = StringConst.empty;
    this.specialitys = StringConst.empty;
    this.displays = StringConst.empty;
    this.generalSearch = StringConst.empty;
    this.specialityDoctor = StringConst.empty;
    this.priceListId = NumberCons.zero;
    this.clientType = StringConst.empty;
  }
}
export class ParamsSearch extends BaseParamsSearch {
  catalogGroup: string;
  itemCode: string;
  subLines: string;
  sugested: number;
  userRole: string;
  searchItemCodeExact: boolean;
  constructor() {
    super();
    this.catalogGroup = StringConst.empty;
    this.itemCode = StringConst.empty;
    this.subLines = StringConst.empty;
    this.sugested = NumberCons.zero;
    this.userRole = StringConst.empty;
    this.searchItemCodeExact = BooleanCons.false;
  }
}

export class GeneralParamsSearch extends BaseParamsSearch {
  catalogsGroup: string[];
  constructor() {
    super();
    this.catalogsGroup = [];
  }
}

export class PriorityCategories {
  priority: string;
  indexAccordion: boolean;
  constructor() {
    this.priority = StringConst.empty;
    this.indexAccordion = BooleanCons.false;
  }
}

export class ParamsSearchForGroup {
  groupName: string;
  groupParams: string;
  inputText: string;
  inputDescription: string;
  typeUI?: TypeUI = TypeUI.input;
  itemsSelected: ItemClassification[] = [];
  idSpecialityByAliment: number;
  idAlimentByActive: number;
  specialityIds: number[] = [];
  ailmentIds: number[] = [];
  generateSearch: boolean;
  constructor() {
    this.groupName = StringConst.empty;
    this.groupParams = StringConst.empty;
    this.inputText = StringConst.empty;
    this.inputDescription = StringConst.empty;
    this.idSpecialityByAliment = NumberCons.zero;
    this.idAlimentByActive = NumberCons.zero;
    this.specialityIds = [];
    this.generateSearch = true;
  }
}
export class InputSelects {
  constructor(
    public value: string,
    public selected: boolean = false,
    public specialityIds: number[],
    public ailmentIds: number[]
  ) { }
}
export class ValidateParamsSearchForGroup {
  paramsSearchForGroup: ParamsSearchForGroup;
  inputSelect: InputSelects;
  constructor() {
    this.paramsSearchForGroup = new ParamsSearchForGroup();
    this.inputSelect = new InputSelects('', false, [], []);
  }
}

export enum TypeUI {
  input,
  select,
}
export class ConfigInputStyle {
  ailment: string;
  speciality: string;
  active: string;
  presentation: string;
  generalSearch: string;
  code: string;
  subLines: string;
  erase: string;
  constructor() {
    this.ailment = StringConst.empty;
    this.speciality = StringConst.empty;
    this.active = StringConst.empty;
    this.presentation = StringConst.empty;
    this.generalSearch = StringConst.empty;
    this.code = StringConst.empty;
    this.subLines = StringConst.empty;
    this.erase = StringConst.empty;
  }
}
export interface CatalogFieldResponse extends BaseResponseHttp {
  response: CatalogField[];
}
export class CatalogField {
  id: number;
  value: string;
  type: string;
  field: string;
  constructor() {
    this.id = NumberCons.zero;
    this.value = StringConst.empty;
    this.type = StringConst.empty;
    this.field = StringConst.empty;
  }
}
export enum CatalogFields {
  oxxoLimit = 'PaymentLimitOxxo',
  cardLimit = 'PaymentLimitCard',
  webinar = 'Webbinar',
  labelQuantityMessage = 'ActiveLabelMessage',
  minPiecesQuantity = 'MinQuantityForCustomLabel'
}

export class CatalogFiscalRegimeResponseClass extends BaseResponseHttp {
  response: TCatalogFiscalRegimeItem[];
  constructor() {
    super();
    this.response = [];
  }
}

export type TCatalogFiscalRegimeItem = {
  id: number;
  code: string;
  description: string;
};

export class InvalidBusinessNameResponseClass extends BaseResponseHttp {
  response: TInvalidBusinessNameItem[];
  constructor() {
    super();
    this.response = [];
  }
}

export type TInvalidBusinessNameItem = {
  id: number;
  value: string;
  type: string;
  field: string;
};

export const GeneralFiltersStatus: { [key: string]: string[] } = {
  sublines: ['reve'],
  ailments: ['dermazone'],
  actives: ['dermazone', 'bioequal', 'bioelite', 'omigenomics'],
  presentation: ['dermazone', 'bioelite'],
  speciality: ['bioequal', 'bioelite', 'omigenomics'],
};
export class ActiveFilters {
  sublines = true;
  ailments = true;
  actives = true;
  presentation = true;
  speciality = true;
}
export interface PowerBiReportResponse {
  response: PowerBiData;
}
export interface PowerBiData {
  type: string;
  embedReport: EmbedReport;
  embedToken: EmbedToken;
}


export interface EmbedReport {
  reportId: string;
  embedUrl: string;
}

export interface EmbedToken {
  token: string;
  tokenId: string;
  expiration: Date;
}

export enum PowerBIReportTypes {
  businessAnalysis = 'BusinessAnalysis',
  businessPotential = 'BusinessPotential',
}
